import { useEffect, useState } from "react";
import { BadgeCheck, MapPin } from "lucide-react";
import { api, hirePhoto } from "../../lib/api";
import { useLang } from "../../context/LanguageContext";
import { Reveal, Overline } from "../Reveal";

export default function Hires() {
  const { t } = useLang();
  const [hires, setHires] = useState([]);

  useEffect(() => {
    api.get("/hires").then((r) => setHires(r.data)).catch(() => {});
  }, []);

  return (
    <section className="relative py-28 px-6 sm:px-12 bg-white border-y border-[#1B2A4E]/8" data-testid="hires-section">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <Overline>{t("hires.overline")}</Overline>
          <h2 className="font-head font-black text-3xl sm:text-5xl text-[#1B2A4E]">{t("hires.title")}</h2>
          <p className="text-[#1B2A4E]/60 mt-3 max-w-xl mb-14">{t("hires.sub")}</p>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          {hires.map((h, i) => (
            <Reveal key={h.id} delay={i * 0.08}>
              <div data-testid={`hire-card-${i}`} className={`group relative ${i % 2 === 1 ? "md:translate-y-8" : ""}`}>
                <div className="relative overflow-hidden clip-portrait bg-[#1B2A4E]/10 aspect-[3/4] shadow-lg shadow-[#1B2A4E]/10">
                  <img
                    src={hirePhoto(h)}
                    alt={h.name}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1B2A4E]/90 via-transparent to-transparent" />
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 shadow-[inset_0_0_60px_rgba(232,132,44,0.35)]" />
                  <div className="absolute top-3 end-3 flex items-center gap-1 bg-white/90 backdrop-blur rounded-full px-2.5 py-1">
                    <BadgeCheck className="w-3.5 h-3.5 text-[#E8842C]" />
                    <span className="text-[10px] font-bold text-[#1B2A4E]">{t("hires.verified")}</span>
                  </div>
                  <div className="absolute bottom-0 inset-x-0 p-4">
                    <p className="font-head font-bold text-white text-sm sm:text-base">{h.name}</p>
                    <p className="text-[11px] text-[#F5A623] font-bold">{h.profession}</p>
                    <p className="text-[11px] text-slate-300 flex items-center gap-1 mt-1">
                      <MapPin className="w-3 h-3" /> {h.country}
                    </p>
                  </div>
                </div>
                <span className="absolute -bottom-3 start-4 bg-[#E8842C] text-white text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full shadow-lg shadow-orange-500/40">
                  {h.visa_status}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
